// Static marketing content for the Digital Tech Solutions clone

export const NAV_LINKS = [
  { label: 'Home', path: '/', key: 'nav.home' },
  { label: 'Chi Siamo', path: '/chi-siamo', key: 'nav.chi_siamo' },
  { label: 'Servizi', path: '/servizi', key: 'nav.servizi' },
  { label: 'Formazione e Corsi', path: '/formazione', key: 'nav.formazione' },
  { label: 'Club', path: '/club', key: 'nav.club' },
  { label: 'ACDT', path: '/acdt', key: 'nav.acdt' },
  { label: 'Energy Power', path: '/energy-power', key: 'nav.energy' },
  { label: 'Robotica', path: '/robotica', key: 'nav.robotica' },
  { label: 'Blog', path: '/blog', key: 'nav.blog' },
  { label: 'Contatti', path: '/contatti', key: 'nav.contatti' },
];

export const SERVICES = [
  {
    key: 'ai',
    tag: 'AI & Automazioni',
    title: 'Intelligenza Artificiale e Automazioni per il business',
    desc: 'Progettiamo soluzioni basate su Intelligenza Artificiale e automazioni in grado di ottimizzare i processi aziendali, ridurre i tempi operativi e migliorare la qualita delle decisioni strategiche.',
    long: 'Dall automazione dei flussi di lavoro all analisi intelligente dei dati, l AI diventa uno strumento concreto per aumentare efficienza, controllo e competitivita.',
    image: 'https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
    points: ['Automazione flussi di lavoro', 'Analisi predittiva dei dati', 'Chatbot e assistenti AI', 'Ottimizzazione decisionale'],
  },
  {
    key: 'blockchain',
    tag: 'Blockchain, Tokenizzazione & E-commerce',
    title: 'Blockchain ed E-commerce evoluto per il business digitale',
    desc: 'Sviluppiamo soluzioni digitali avanzate che integrano Blockchain, tokenizzazione ed E-commerce evoluti per creare modelli di business sicuri, tracciabili e scalabili.',
    long: 'Dalla tokenizzazione ai sistemi digitali per la tracciabilita, alle piattaforme e-commerce personalizzate, supportiamo aziende e professionisti nella vendita online.',
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
    points: ['Smart contract e tokenizzazione', 'E-commerce personalizzati', 'Tracciabilita e supply chain', 'Sicurezza dei dati'],
  },
  {
    key: 'formazione',
    tag: 'Formazione & Consulenza',
    title: 'Formazione certificata e consulenza strategica',
    desc: 'Offriamo percorsi di formazione certificata e consulenze specialistiche per sviluppare competenze digitali realmente spendibili.',
    long: 'Affianchiamo professionisti e aziende nel percorso di crescita, unendo conoscenza teorica, casi pratici e supporto operativo continuo.',
    image: 'https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
    points: ['Corsi certificati', 'Casi pratici reali', 'Supporto operativo continuo', 'Percorsi personalizzati'],
  },
];

export const FEATURES = [
  { title: 'Soluzioni Digitali Integrate', desc: 'Piattaforme e strumenti tecnologici progettati per adattarsi ai reali processi di aziende e professionisti.' },
  { title: 'Tecnologia Applicata al Business', desc: 'AI, Blockchain e automazioni utilizzate in casi concreti per migliorare efficienza, controllo e risultati.' },
  { title: 'Formazione Certificata', desc: 'Percorsi formativi strutturati per creare competenze spendibili nel mercato digitale e sostenibile.' },
  { title: 'Ecosistema di Partner', desc: 'Una rete di aziende, consulenti e professionisti che condividono visione, valori e crescita.' },
];

export const STATS = [
  { value: 95, suffix: '%', label: 'Successo dei Progetti', desc: 'Il 95% dei progetti digitali raggiunge gli obiettivi concordati.' },
  { value: 650, prefix: 'EUR ', suffix: 'K', label: 'Ottimizzazione dei Costi', desc: 'Oltre 650mila euro di costi ottimizzati grazie a soluzioni digitali.' },
  { value: 87, suffix: '%', label: 'Tasso di Conversione', desc: 'Incremento medio delle conversioni per i nostri clienti.' },
  { value: 1200, suffix: '+', label: 'Clienti Soddisfatti', desc: 'Professionisti e aziende che si affidano a noi.' },
];

export const TEAM = [
  { name: 'CEO', role: 'Founder & CEO', tag: 'Vision', img: '/team-roccaro.jpg', bio: 'Guida la visione strategica di Digital Tech Solutions tra AI, blockchain e sostenibilita, costruendo un ecosistema digitale certificato.' },
];

export const ACDT_RECOGNITION = 'Percorso riconosciuto anche tramite l Associazione ACDT come figura professionale certificata.';

export const TESTIMONIALS = [
  { name: 'Marco Rossi', role: 'CEO, TechRetail', text: 'Grazie a Digital Tech Solutions abbiamo automatizzato i processi e aumentato il fatturato del 40% in sei mesi. Un partner affidabile e competente.' },
  { name: 'Giulia Bianchi', role: 'Founder, GreenShop', text: 'Il percorso di formazione certificata mi ha aperto nuove opportunita professionali. Contenuti di altissima qualita e supporto costante.' },
  { name: 'Luca Ferrari', role: 'Consulente Digitale', text: 'L e-commerce personalizzato e gli strumenti di tracciabilita hanno rivoluzionato la mia attivita. Partner affidabili e sempre presenti.' },
  { name: 'Sara Conti', role: 'Marketing Manager', text: 'La strategia B100 ha fidelizzato i nostri clienti senza abbassare i prezzi. Risultati concreti e misurabili.' },
  { name: 'Davide Greco', role: 'Imprenditore', text: 'Professionalita e visione. L approccio sostenibile fa davvero la differenza per il futuro del business.' },
  { name: 'Elena Marini', role: 'Studentessa ACDT', text: 'La Academy e semplicemente eccezionale. Il tutor AI mi accompagna passo passo. Ho ottenuto la certificazione e un lavoro.' },
];

export const PARTNERS = ['NexaTech', 'PagoFlow', 'GreenGrid', 'DataFlow', 'CloudNine', 'ChainLedger', 'AI Labs', 'EcoSmart'];

export const BLOG_POSTS = [
  { id: 1, date: 'Luglio 15, 2025', author: 'admin', category: 'Formazione', title: 'Perche le competenze digitali valgono piu della tecnologia', excerpt: 'La tecnologia cambia, le competenze restano. Scopri perche investire nella formazione digitale e la scelta piu strategica per il futuro.', img: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
  { id: 2, date: 'Luglio 8, 2025', author: 'admin', category: 'AI', title: 'Come l Intelligenza Artificiale sta cambiando le PMI italiane', excerpt: 'Casi concreti di automazione e AI applicata alle piccole e medie imprese. Efficienza, risparmio e nuove opportunita.', img: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
  { id: 3, date: 'Giugno 30, 2025', author: 'admin', category: 'Blockchain', title: 'Tokenizzazione e tracciabilita: come innovare il tuo business', excerpt: 'Smart contract, tokenizzazione e supply chain tracciabile sono gia realta operative per PMI e professionisti. Scopri come integrarle.', img: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=800' },
];

export const CONTACT_INFO = {
  company: 'Digital Tech Solutions',
  companyFull: 'Digital Tech Solutions',
  owner: 'Digital Tech Solutions',
  address: 'Via Pietro Nenni, 16 - 97015 Modica RG',
  phone: '+39 377 366 0476',
  email: 'info@digitaltechsolutions.it',
  pec: 'digitaltechsolutions@pec.it',
  vat: '01899170888',
  taxCode: '01899170888',
  rea: '',
};

export const LEGAL_INFO = {
  // Data controller / titolare del trattamento
  controller: {
    name: 'Digital Tech Solutions',
    owner: 'Digital Tech Solutions',
    address: 'Via Pietro Nenni, 16 - 97015 Modica (RG) - Italia',
    vat: '01899170888',
    taxCode: '01899170888',
    rea: '',
    email: 'info@digitaltechsolutions.it',
    pec: 'digitaltechsolutions@pec.it',
    phone: '+39 377 366 0476',
  },
  // 3rd party data processors (responsabili esterni)
  processors: [
    { name: 'Stripe Payments Europe, Ltd.', purpose: 'elaborazione pagamenti e abbonamenti', country: 'Irlanda / USA', privacy: 'https://stripe.com/it/privacy' },
    { name: 'MongoDB Atlas (hosting dati)', purpose: 'archiviazione dati applicativi', country: 'UE', privacy: 'https://www.mongodb.com/legal/privacy-policy' },
    { name: 'SendGrid (Twilio Inc.)', purpose: 'invio email transazionali e di notifica', country: 'USA (SCC)', privacy: 'https://www.twilio.com/legal/privacy' },
    { name: 'OpenStreetMap / Leaflet', purpose: 'rendering mappe (totem ChargeBull)', country: 'UE/UK', privacy: 'https://wiki.osmfoundation.org/wiki/Privacy_Policy' },
    { name: 'A.C.D.T. - Associazione Consulenti e Consumatori Digitali', purpose: 'gestione tesseramento e Registro Nazionale (solo per utenti che acquistano pacchetti relativi)', country: 'Italia', privacy: 'https://assoacdt.com/privacy-policy' },
  ],
  // ADR/ODR (Codice del Consumo)
  adrOdr: 'https://ec.europa.eu/consumers/odr',
  // Legge 4/2013 (professioni non organizzate)
  l42013:
    'La formazione erogata e associata alla figura professionale non organizzata ex Legge 14 gennaio 2013, n. 4. Il titolo di Consulente Digitale Tecnologico e di Sostenibilita e rilasciato in collaborazione con A.C.D.T., iscritta all elenco MIMIT dell aggregazione delle associazioni professionali.',
};
